export default "__VITE_ASSET__BijPqubb__"